{
  "name": "@ns/company-network-access-approve",
  "version": "1.1.0",
  "requiredPermission": "RELATIONSHIPS_MANAGE",
  "description": "Review and respond to a network access request",
  "inputs": {
    "REQUESTER_COMPANY_ID": {
      "type": "string"
    },
    "GRANTOR_COMPANY_ID": {
      "type": "string"
    },
    "RELATIONSHIP_ID": {
      "type": "string"
    }
  },
  "outcomes": {
    "approve": {},
    "reject": {}
  }
}
